import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ConsentPanelComponent } from './consent-panel.component';
import { ConsentService } from '../services/consent.service';

@Component({
  selector: 'app-consent-banner',
  imports: [ConsentPanelComponent, MatIconModule],
  templateUrl: './consent-banner.component.html',
  standalone: true
})
export class ConsentBannerComponent {
  private readonly consentService = inject(ConsentService);

  dismiss(): void {
    this.consentService.dismiss();
  }
}
